import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield } from 'lucide-react';
import PDFViewer from '../components/PDFViewer';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-blue-50">
      <div className="container-professional py-12">
        <div className="max-w-6xl mx-auto">
          <div className="mb-8">
            <Link
              to="/welcome"
              className="inline-flex items-center space-x-2 text-gray-600 hover:text-ios-blue mb-6 transition-colors"
            >
              <ArrowLeft className="w-5 h-5" />
              <span>Terug naar home</span>
            </Link>

            <div className="bg-gradient-to-r from-ios-blue to-blue-600 rounded-2xl shadow-lg p-8 text-white">
              <div className="flex items-center space-x-4">
                <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center">
                  <Shield className="w-8 h-8" />
                </div>
                <div>
                  <h1 className="text-4xl font-bold mb-2">Privacy Policy</h1>
                  <p className="text-blue-100">Live PDF weergave</p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-lg border-2 border-gray-200 p-8">
            <PDFViewer pdfPath="/policies/Privacy_Policy.pdf" title="Privacy Policy" />
          </div>
        </div>
      </div>
    </div>
  );
}
